import { DateRange } from 'react-day-picker'

import { FiltersDefinition, FiltersState, IconType } from '@factorialco/f0-react'
import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { AnalyticsTraceabilityResultsDocument } from 'generated/resources/graphql'
import moment from 'moment'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ColumnFormatHint } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'

import TraceabilityTableContent from './TraceabilityTableContent'

interface ReportTableAction {
  label: string
  icon: IconType
  onClick: () => void
}

interface ReportTableProps {
  id: string
  dateFilter?: DateRange
  reportName: string
  sqlQuery: string
  actions?: {
    primary?: ReportTableAction
    secondary?: ReportTableAction[]
  }
  columnFormatHints: ColumnFormatHint[]
  onStateChange: React.ComponentProps<typeof OneDataCollection>['onStateChange']
  tableId: string
  onUserFacingSqlQueryChange: (sqlQuery: string) => void
  currentFilters: FiltersState<FiltersDefinition<string>> | undefined
}

const INITIAL_PAGE = 1
const INITIAL_PAGE_SIZE = 10

const ReportTable = ({
  id,
  sqlQuery,
  actions,
  columnFormatHints,
  onStateChange,
  tableId,
  dateFilter,
  onUserFacingSqlQueryChange,
  currentFilters,
}: ReportTableProps) => {
  const { company } = useCurrentSession()

  // Used to fetch the columns.
  const { data: columnsData } = useQuery(AnalyticsTraceabilityResultsDocument, {
    variables: {
      query: sqlQuery,
      companyId: company.id,
      dateRange: {
        from: moment().startOf('year').toDate().toISOString(),
        to: moment().endOf('year').toDate().toISOString(),
      },
      page: INITIAL_PAGE,
      perPage: INITIAL_PAGE_SIZE,
      tableId: tableId,
    },
  })

  if (!columnsData) {
    return <Loading />
  }

  return (
    <TraceabilityTableContent
      id={id}
      sqlQuery={sqlQuery}
      tableId={tableId}
      actions={actions}
      columnFormatHints={columnFormatHints}
      onStateChange={onStateChange}
      dateFilter={dateFilter}
      onUserFacingSqlQueryChange={onUserFacingSqlQueryChange}
      columnsData={columnsData}
      currentFilters={currentFilters}
    />
  )
}

export default ReportTable
export { type ReportTableAction, type ReportTableProps }
